import { jsx, jsxs } from "react/jsx-runtime";
import { createContext, forwardRef, useMemo, useContext } from "react";
import { Slot } from "@radix-ui/react-slot";
import { IconWrapper } from "../IconWrapper/index.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import { cn as clsx } from "../../helpers/react.js";
import '../../assets/index28.css';const qaButton = "_qaButton_1nbu1_1";
const content = "_content_1nbu1_48";
const leftSection = "_leftSection_1nbu1_57";
const buttonText = "_buttonText_1nbu1_64";
const primary = "_primary_1nbu1_76";
const numeric = "_numeric_1nbu1_79";
const icon = "_icon_1nbu1_90";
const image = "_image_1nbu1_95";
const disabled = "_disabled_1nbu1_99";
const s = {
  qaButton,
  content,
  leftSection,
  buttonText,
  primary,
  numeric,
  icon,
  image,
  disabled
};
const ButtonContext = createContext({});
const QAText = withThemeAndSize(
  forwardRef(({ className, children, numeric: numeric2, primary: primary2 = true, ...rest }, ref) => {
    return /* @__PURE__ */ jsx(
      "span",
      {
        ...rest,
        className: clsx(
          s.buttonText,
          {
            [s.numeric]: numeric2,
            [s.primary]: primary2
          },
          className
        ),
        ref,
        children
      }
    );
  })
);
const QAButton = withThemeAndSize(
  forwardRef(({ className, leftSection: leftSection2, rightIcon, rightIconSize, children, ...rest }, ref) => {
    const context = useMemo(() => ({ disabled: rest.disabled }), [rest.disabled]);
    return /* @__PURE__ */ jsx(ButtonContext.Provider, { value: context, children: /* @__PURE__ */ jsxs("button", { ...rest, type: "button", className: clsx(s.qaButton, className), ref, children: [
      leftSection2 && /* @__PURE__ */ jsx("div", { className: s.leftSection, children: leftSection2 }),
      children && /* @__PURE__ */ jsx("div", { className: clsx(s.content), children }),
      rightIcon && /* @__PURE__ */ jsx(IconWrapper, { size: rightIconSize || "sm", className: s.icon, children: rightIcon })
    ] }) });
  })
);
const QAImage = withThemeAndSize(
  forwardRef(({ className, disabled: disabledFromProps, asChild, ...rest }, ref) => {
    const context = useContext(ButtonContext);
    const disabled2 = disabledFromProps ?? (context == null ? void 0 : context.disabled);
    const Comp = asChild ? Slot : "img";
    return /* @__PURE__ */ jsx(IconWrapper, { size: "md", children: /* @__PURE__ */ jsx(
      Comp,
      {
        ...rest,
        className: clsx(
          s.image,
          {
            [s.disabled]: disabled2
          },
          className
        ),
        ref
      }
    ) });
  })
);
const QAIcon = withThemeAndSize(
  forwardRef(({ className, children, disabled: disabledFromProps, ...rest }, ref) => {
    const context = useContext(ButtonContext);
    const disabled2 = disabledFromProps ?? (context == null ? void 0 : context.disabled);
    return /* @__PURE__ */ jsx(
      IconWrapper,
      {
        ...rest,
        size: "md",
        className: clsx(
          s.icon,
          {
            [s.disabled]: disabled2
          },
          className
        ),
        ref,
        children
      }
    );
  })
);
const QAPanelButton = Object.assign(QAButton, {
  Text: QAText,
  LeftSectionImg: QAImage,
  LeftSectionIcon: QAIcon
});
export {
  QAPanelButton
};
